/**
 * Wire contract for the admin dashboard analytics endpoint
 * (`GET /admin/metrics?window=<w>`).
 *
 * Drives the admin SPA dashboard's v1 tiles:
 *   1. GMV·7д        — daily gmv / paid / refunds series + total + deltaPct.
 *   2. Order-structure donut — order count broken down by status.
 *   3. Online-now    — inspectors currently online (manual availability) / total active.
 *   4. Orders-by-hour — 24-bucket histogram of order creation, Minsk local hour.
 *
 * The `window` query param selects the analysis range; the server buckets
 * every day / hour boundary in **Europe/Minsk** local time (fixed UTC+3, no
 * DST since 2011) so cross-midnight payments land in the correct local day.
 *
 * **All amounts are `number`** (BYN, rounded server-side from the Postgres
 * `Decimal` columns). A `Decimal` is NEVER placed on the wire — the admin
 * service rounds to 2dp before serialising. The client renders charts
 * directly from the numbers/arrays here; the backend returns NO SVG geometry
 * or chart config (the SPA computes that).
 *
 * Series arrays are always **zero-filled** to the full expected length (one
 * entry per calendar day in the window; exactly 24 entries for the hourly
 * histogram) — the SPA's SVG path builder assumes a dense series and would
 * crash on gaps.
 *
 * Centralised in `@carcheck/shared` so the api + admin packages import the
 * same source of truth — no api↔admin mirror drift.
 */
/**
 * Allowed analysis windows. The controller rejects any other string (400)
 * via the Zod allow-list so an arbitrary `?window=foo` can't reach the
 * service and blow up the day-count math.
 */
export const ADMIN_METRICS_WINDOWS = ['24h', '7d', '30d', '90d'];
//# sourceMappingURL=admin-metrics.js.map